import React from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { ToastContainer as ReactToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

import { BACKGROUND_RED, NOTIFICATION_ORANGE, PURPLE_MAIN, STATUS_GREEN } from 'theme/colors';
import { type ThemeName, ThemeNameEnum } from 'typedefs/themeTypes';

interface ToastContainerProps {
  themeName: ThemeName;
}

const toastVariables = (themeName: ThemeName) => ({
  '--toastify-color-light': NOTIFICATION_ORANGE,
  '--toastify-color-info': PURPLE_MAIN,
  '--toastify-color-success': STATUS_GREEN,
  '--toastify-color-warning': NOTIFICATION_ORANGE,
  '--toastify-color-error': BACKGROUND_RED,
  '--toastify-text-color-light': 'white',
  '--toastify-font-family': themeName === ThemeNameEnum.V1 ? 'sans-serif' : 'poppins',
});

const ToastContainer: React.FC<ToastContainerProps> = React.memo(({ themeName }) => (
  <ReactToastContainer
    closeOnClick
    hideProgressBar
    closeButton={<CloseIcon />}
    icon={false}
    position="top-center"
    style={toastVariables(themeName) as any}
    theme="colored"
  />
));

export default ToastContainer;
